import { LOGO_URL, WHATSAPP_LINK, WHATSAPP_NUMBER, COMPANY_NAME, REGION, SLOGAN, WHATSAPP_PASSENGERS_GROUP } from "../../lib/troy";
import { MessageCircle, MapPin, Instagram } from "lucide-react";

export default function Footer() {
  const formatted = `+55 (${WHATSAPP_NUMBER.slice(0, 2)}) ${WHATSAPP_NUMBER.slice(2, 7)}-${WHATSAPP_NUMBER.slice(7)}`;
  return (
    <footer
      id="contato"
      data-testid="site-footer"
      className="relative bg-black border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        {/* Giant CTA */}
        <div className="text-center mb-20">
          <p className="text-xs tracking-[0.25em] uppercase text-[#FFCC00] font-bold mb-4">
            Pronto pra viajar com a Troy?
          </p>
          <a
            href={WHATSAPP_PASSENGERS_GROUP}
            target="_blank"
            rel="noreferrer noopener"
            data-testid="footer-giant-cta"
            className="font-display font-black tracking-tighter leading-[0.9] block text-[18vw] md:text-[13vw] lg:text-[11vw] hover:text-[#FFCC00] transition-colors"
          >
            CHAME A TROY
          </a>
          <p className="text-white/50 mt-4 italic font-display">"{SLOGAN}"</p>
        </div>

        {/* Info grid */}
        <div className="grid md:grid-cols-4 gap-10 pt-10 border-t border-white/10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={LOGO_URL}
                alt={COMPANY_NAME}
                className="logo-ring h-14 w-14 rounded-xl object-contain bg-black border border-[#FFCC00]/30 drop-shadow-[0_0_22px_rgba(255,59,48,0.35)]"
              />
              <div>
                <p className="font-display text-xl font-black">{COMPANY_NAME}</p>
                <p className="text-xs uppercase tracking-[0.25em] text-[#FFCC00]">
                  Transporte urbano
                </p>
              </div>
            </div>
            <p className="text-white/60 max-w-md leading-relaxed">
              Grupo de transporte com corridas rápidas, seguras e preço justo.
              Motoristas verificados atendendo {REGION}. Pedindo no grupo, você
              ainda concorre a prêmios todo mês.
            </p>
          </div>

          <div>
            <p className="font-bold mb-4">Contato</p>
            <ul className="space-y-3 text-white/70">
              <li className="flex items-start gap-2">
                <MessageCircle className="w-4 h-4 text-[#FFCC00] mt-1 flex-shrink-0" />
                <a
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noreferrer noopener"
                  data-testid="footer-whatsapp-link"
                  className="hover:text-[#FFCC00] transition-colors"
                >
                  {formatted}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-[#FFCC00] mt-1 flex-shrink-0" />
                <span>General Carneiro e regiões próximas</span>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-bold mb-4">Navegação</p>
            <ul className="space-y-2 text-white/70">
              <li><a href="#sobre" className="hover:text-[#FFCC00]">Sobre</a></li>
              <li><a href="#servicos" className="hover:text-[#FFCC00]">Serviços</a></li>
              <li><a href="#passageiros" className="hover:text-[#FFCC00]">Passageiros</a></li>
              <li><a href="#premios" className="hover:text-[#FFCC00]">Prêmios mensais</a></li>
              <li><a href="#motoristas" className="hover:text-[#FFCC00]">Motoristas</a></li>
              <li>
                <a
                  href={WHATSAPP_PASSENGERS_GROUP}
                  target="_blank"
                  rel="noreferrer noopener"
                  data-testid="footer-passengers-group-link"
                  className="hover:text-[#FFCC00]"
                >
                  Grupo de Passageiros
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-4 text-sm text-white/40">
          <p>
            © {new Date().getFullYear()} {COMPANY_NAME}. Todos os direitos reservados.{" "}
            <a
              href="/admin"
              data-testid="footer-admin-link"
              className="text-white/25 hover:text-[#FFCC00] transition-colors underline underline-offset-4"
            >
              Área do administrador
            </a>
          </p>
          <div className="flex items-center gap-3">
            <span>Siga a Troy</span>
            <a
              href="#"
              aria-label="Instagram"
              className="p-2 rounded-full border border-[#FFCC00]/15 hover:border-[#FFCC00] hover:text-[#FFCC00] transition-colors"
              data-testid="footer-instagram"
            >
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
